import { call, put, select } from 'redux-saga/effects'
import { ApiResponse } from 'apisauce'

import api from 'src/services/api'

import { ApplicationState } from 'src/core/store'
import { ClientNotifyCatch } from 'src/config/bugsnag'

import { ResponseDataUsers } from './types'
import * as Actions from './actions'

export function* getUsers({
  payload: { search }
}: ReturnType<typeof Actions.getUsers>) {
  try {
    const {
      me: {
        organization: { organization_id }
      }
    } = yield select((state: ApplicationState) => state)

    const queryString = `?organization_id=${organization_id}${
      search ? `&search=${search}` : ''
    }`
    const { data, ok }: ApiResponse<ResponseDataUsers> = yield call(
      api.get,
      `users${queryString}`
    )

    if (ok) {
      const users = data.users.sort((a, b) =>
        `${a.first_name} ${a.last_name}` > `${b.first_name} ${b.last_name}`
          ? 1
          : -1
      )
      yield put(Actions.getUsersSuccess(users))
      return
    }

    yield put(Actions.getUsersFailure())
  } catch (err) {
    ClientNotifyCatch('Saga getUsers', err)
    yield put(Actions.getUsersFailure())
  }
}
